/**
 * 募集職種一覧（jobs アーカイブ）専用スクリプト
 *   - SP: 「条件で絞り込む」ボタンでフィルタをモーダル表示 / 閉じる
 *         （絞り込み確定はフォーム送信＝ページ遷移。条件はサーバー側で保持）
 *   - 並び替え（新着順 / 年収順）: Ajax でカード＋ページャーをシームレスに差し替え
 *         現在の絞り込み条件は URL パラメータごと引き継ぐ
 */
export default function jobs() {
  const modal = document.getElementById('js-jobs-modal');
  if (!modal) return; // このページ以外では何もしない

  /* ========== SP モーダル開閉 ========== */
  const openBtns = document.querySelectorAll('[data-jobs-open]');
  const closeBtns = document.querySelectorAll('[data-jobs-close]');
  const OPEN_CLASS = 'is-open';
  const LOCK_CLASS = 'is-jobs-modal-open';

  const open = () => {
    modal.classList.add(OPEN_CLASS);
    document.documentElement.classList.add(LOCK_CLASS);
  };
  const close = () => {
    modal.classList.remove(OPEN_CLASS);
    document.documentElement.classList.remove(LOCK_CLASS);
  };

  openBtns.forEach((btn) => btn.addEventListener('click', open));
  closeBtns.forEach((btn) => btn.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains(OPEN_CLASS)) close();
  });

  /* ========== 並び替え（Ajax） ========== */
  const list = document.getElementById('js-jobs-list');
  const pager = document.getElementById('js-jobs-pager');
  const count = document.getElementById('js-jobs-count');
  const sortWrap = document.getElementById('js-jobs-sort');
  // window.CWC_JOBS は wp_localize_script で出力
  const conf = window.CWC_JOBS;

  if (!list || !sortWrap || !conf) return;

  const sortLinks = sortWrap.querySelectorAll('[data-sort]');

  sortLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (link.classList.contains('is-current')) return;

      // クリックしたリンクの href（現在の絞り込み＋新しい sort）をそのまま利用
      const url = new URL(link.href, window.location.origin);
      const params = url.searchParams;

      list.classList.add('is-loading');

      const body = new URLSearchParams();
      body.set('action', 'cwc_jobs_sort');
      body.set('nonce', conf.nonce);
      body.set('query', params.toString());

      fetch(conf.ajaxurl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
        .then((res) => res.json())
        .then((res) => {
          if (!res || !res.success) return;

          list.innerHTML = res.data.cards;
          if (pager) pager.innerHTML = res.data.pager || '';
          if (count) count.textContent = `${res.data.total}件`;

          // 現在の並び替えを更新
          sortLinks.forEach((l) => l.classList.toggle('is-current', l === link));

          // URL を更新（sort を保持・絞り込みも維持）
          window.history.pushState(null, '', url.pathname + url.search);
        })
        .finally(() => {
          list.classList.remove('is-loading');
        });
    });
  });
}
